import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

// Ignore opaque cross-origin "Script error." events (no stack / not from app code —
// e.g. preview-platform instrumentation or browser extensions). Prevents the dev
// error overlay from interrupting on errors that carry no actionable information.
window.addEventListener(
  "error",
  (e) => {
    if (e && e.message === "Script error." && !e.error) {
      e.stopImmediatePropagation();
    }
  },
  true,
);

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);

if ("serviceWorker" in navigator && process.env.NODE_ENV === "production") { window.addEventListener("load", () => navigator.serviceWorker.register("/sw.js").catch(() => {})); }
window.addEventListener("unhandledrejection", (e) => {
  const r = e.reason || {};
  if (r.code === "ERR_NETWORK" || r.message === "Network Error") e.preventDefault(); // offline: queue/cache already handled it
});
